// components/WhatsappSubscription.jsx

import {
    Alert,
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Snackbar,
    TextField,
    Typography,
} from "@mui/material";
import axios from "axios";
import { useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useNavigate } from "react-router-dom";
import { configUrl } from "../config";


const WhatsappSubscription = ({
    open,
    onClose,
    price = 500,
    title = "Join WhatsApp Group",
    type,
    CPFiltersValues
}) => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: "",
        mobile: "",
        email: "",
    });

    const [loading, setLoading] = useState(false);

    const [alert, setAlert] = useState({
        open: false,
        message: "",
        severity: "error",
    });

    const showAlert = (message, severity = "error") => {
        setAlert({
            open: true,
            message,
            severity,
        });
    };

    const razorpay_key = configUrl.razorPayKey;

    const generateEmail = (name) => {
        return (
            name
                .trim()
                .toLowerCase()
                .replace(/\s+/g, ".")
                .replace(/[^a-z0-9.]/g, "")
            + "@medineer.ai"
        );
    };

    const loadRazorpayScript = () =>
        new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.onload = () => resolve(true);
            script.onerror = () => resolve(false);
            document.body.appendChild(script);
        });

    const createOrder = async (amount) => {
        const res = await axios.post(
            `${configUrl.AssessmentServer}/api/Payments/createOrder/${amount}`
        );

        return res.data.orderId;
    };

    const sendEmail = async (status, orderId) => {

        await axios.post(
            `${configUrl.AssessmentServer}/api/Coupon/whatsAppSubscriptionEmail/${encodeURIComponent(
                formData.name
            )}/${encodeURIComponent(formData.mobile)}/${encodeURIComponent(status)}/${encodeURIComponent(orderId)}`
        );
    };
    const sendPrefrenceListEmail = async (name, mobile, email) => {

        await axios.post(
            `${configUrl.AssessmentServer}/api/Coupon/preferencePdfUserSignupInfo/${name}/${mobile}/${email}`
        );
    };


    const verify = async (resp) => {
        console.log(type, "dataiss", resp);
        if (type == "preferencelist") {
            navigate("/cp-pdf-dashboard", {
                state: {
                    filters: CPFiltersValues,
                    name: formData.name,
                    email: formData.email
                }
            });
            // navigate("/cpreport", {
            //     state: {
            //         filters: CPFiltersValues,
            //         name: formData.name,
            //         email: formData.email
            //     }
            // });
            return;
        }
        let status = "paid"
        let orderId = resp.razorpay_order_id ? resp.razorpay_order_id : null;
        await sendEmail(status, orderId);

        navigate("/success", {
            state: {
                userName: null,
                password: null,
                isWhatsappJoinPage: true,
            },
        });
    };

    const initiatePayment = async () => {
        setLoading(true);

        try {
            const loaded = await loadRazorpayScript();

            if (!loaded) {
                showAlert("Unable to load Razorpay.");
                setLoading(false);
                return;
            }

            const orderId = await createOrder(price);

            const options = {
                key: razorpay_key,
                amount: price * 100,
                currency: "INR",
                name: "Splayndid",
                description: "WhatsApp Subscription",
                order_id: orderId,

                handler: async (resp) => {
                    await verify(resp);
                },

                modal: {
                    ondismiss: () => setLoading(false),
                },

                prefill: {
                    name: formData.name,
                    email: generateEmail(formData.name),
                    contact: formData.mobile,
                },
                theme: {
                    color: "#3399cc",
                },

                config: {
                    display: {
                        hide: [
                            { method: "card" },
                            { method: "netbanking" },
                            { method: "wallet" },
                            { method: "emi" },
                            { method: "paylater" },
                        ],
                    },
                },
            };

            setLoading(false);

            new window.Razorpay(options).open();
        } catch {
            setLoading(false);
            showAlert("Payment failed.");
        }
    };

    const handleSubmit = async () => {
        if (!formData.name.trim()) {
            showAlert("Please enter your name");
            return;
        }

        if (!/^[6-9]\d{9}$/.test(formData.mobile)) {
            showAlert("Enter valid mobile number");
            return;
        }

        onClose();
        let status = "intiated"
        let orderId = null;

        if (type != "preferencelist") {
            await sendEmail(status, orderId);
        }
        if (type == "preferencelist") {
            sendPrefrenceListEmail(formData.name, formData.mobile, formData.email);
        }
        await initiatePayment();
    };

    return (
        <>
            <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
                <DialogTitle sx={{ textAlign: "center", fontWeight: 700 }}>
                    {title}

                    <IconButton
                        onClick={onClose}
                        sx={{
                            position: "absolute",
                            right: 10,
                            top: 10,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent>
                    <TextField
                        fullWidth
                        margin="normal"
                        label="Full Name"
                        value={formData.name}
                        sx={{
                            fontSize: "1.2rem",
                            "& .MuiFormHelperText-root": {
                                fontSize: "1rem", // Increased helper text size
                            },
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "0.75rem", // Apply border radius to the input field
                                backgroundColor: "#F8F9FB", // Input background color
                                fontSize: "1.5rem", // Increase the input text size
                            },
                            "& .MuiInputLabel-root": {
                                fontSize: "1.5rem", // Increase the label text size
                            },
                        }}
                        onChange={(e) =>
                            setFormData((p) => ({
                                ...p,
                                name: e.target.value,
                            }))
                        }
                    />

                    {type == "preferencelist" && <TextField
                        fullWidth
                        margin="normal"
                        label="Email"
                        type="email"
                        value={formData.email}
                        onChange={(e) =>
                            setFormData((p) => ({
                                ...p,
                                email: e.target.value,
                            }))
                        }
                        sx={{
                            fontSize: "1.2rem",
                            "& .MuiFormHelperText-root": {
                                fontSize: "1rem", // Increased helper text size
                            },
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "0.75rem", // Apply border radius to the input field
                                backgroundColor: "#F8F9FB", // Input background color
                                fontSize: "1.5rem", // Increase the input text size
                            },
                            "& .MuiInputLabel-root": {
                                fontSize: "1.5rem", // Increase the label text size
                            },
                        }}
                    />}

                    <TextField
                        fullWidth
                        margin="normal"
                        label="Mobile Number"
                        inputProps={{
                            maxLength: 10,
                        }}
                        value={formData.mobile}
                        onChange={(e) =>
                            setFormData((p) => ({
                                ...p,
                                mobile: e.target.value.replace(/\D/g, "").slice(0, 10),
                            }))
                        }
                        sx={{
                            fontSize: "1.2rem",
                            "& .MuiFormHelperText-root": {
                                fontSize: "1rem", // Increased helper text size
                            },
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "0.75rem", // Apply border radius to the input field
                                backgroundColor: "#F8F9FB", // Input background color
                                fontSize: "1.5rem", // Increase the input text size
                            },
                            "& .MuiInputLabel-root": {
                                fontSize: "1.5rem", // Increase the label text size
                            },
                        }}
                    />
                    {type === "preferencelist" && (
                        <Typography
                            variant="body2"
                            sx={{
                                color: "text.secondary",
                                mt: 0.5,
                                mb: 1,
                                ml: 0.5,
                                mr: 0.5,
                                fontSize: "1.2rem",
                                lineHeight: 1.5,
                            }}
                        >
                            <b>Note: </b>Preference list will be generated after payment. PDF copy will be sent to your email.
                        </Typography>
                    )}
                </DialogContent>

                <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
                    <Button
                        variant="contained"
                        color="success"
                        startIcon={type == "preferencelist" ? null : !loading && <WhatsAppIcon />}
                        disabled={loading}
                        onClick={handleSubmit}
                        sx={{
                            fontSize: '1.4rem',
                            textTransform: 'capitalize'
                        }}
                    >
                        {type == "preferencelist" ?
                            ("Proceed to Payment")
                            : (loading ? (
                                <CircularProgress size={22} color="inherit" />
                            ) : (
                                "Continue"
                            ))}
                    </Button>
                </DialogActions>
            </Dialog >

            <Snackbar
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                open={alert.open}
                autoHideDuration={5000}
                onClose={() =>
                    setAlert((p) => ({
                        ...p,
                        open: false,
                    }))
                }
            >
                <Alert
                    severity={alert.severity}
                    sx={{
                        width: "100%",
                        fontSize: "15px",
                        fontFamily: "Poppins",
                    }}
                >
                    {alert.message}
                </Alert>
            </Snackbar>

            {
                loading && (
                    <Box
                        sx={{
                            position: "fixed",
                            inset: 0,
                            bgcolor: "rgba(255,255,255,.6)",
                            zIndex: 9999,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <CircularProgress />
                    </Box>
                )
            }
        </>
    );
};

export default WhatsappSubscription;